'use client';

import { useGetChannelPref } from '@/providers/ChannelProvider';
import { generateChannelPath } from '@/utils';
import Link from 'next/link';
import { ComponentProps } from 'react';
import { SUB_PATH_CHANNEL_MAP } from '~/url-maps/constant.mjs';
import { normalizeChannelName } from '@/i18n/utils';

type Props = ComponentProps<typeof Link>;

export const LinkWithChannelLink = (props: Props) => {
  const channelPref = useGetChannelPref();
  const channelName = normalizeChannelName(generateChannelPath(channelPref));
  if (!channelName || !(channelName in SUB_PATH_CHANNEL_MAP)) {
    return <Link {...props} />;
  }
  const channel =
    channelName &&
    SUB_PATH_CHANNEL_MAP[channelName as keyof typeof SUB_PATH_CHANNEL_MAP];
  if (channel) {
    return <Link {...props} href={`/${channel}${props.href}`} />;
  }
  return <Link {...props} />;
};

export function useGetChannelLink() {
  const channelPref = useGetChannelPref();
  return function (link: string) {
    const channelName = normalizeChannelName(generateChannelPath(channelPref));
    if (!channelName || !(channelName in SUB_PATH_CHANNEL_MAP)) {
      return link;
    }
    return `/${SUB_PATH_CHANNEL_MAP[channelName as keyof typeof SUB_PATH_CHANNEL_MAP]}${link}`;
  };
}
